const { ToggleButtonGroupComponentDefinition } = require('./toggle-button-group.component');

require('angular')
    .module('wowApp.common')
    .component('wowToggleButtonGroup', ToggleButtonGroupComponentDefinition);



// WEBPACK FOOTER //
// ./src/common/togglebuttongroup/index.js